import { configureStore } from "@reduxjs/toolkit";
import users from "../reducers/users";
import annonces from "../reducers/annonces";
import navigation from "../reducers/navigation";


export const store = configureStore({
    reducer:{
        users,
        annonces,
        navigation
    },
    devTools: true,
})